import React from 'react';

import './LinkableIcon.scss';

const LinkableIcon = ({ url, target = '', icon, classes = '' }) => {
  return icon ? <a className={`linkable-icon ${classes}`} href={url} target={target}>{icon ? icon : ''}</a> : '';
}

export default LinkableIcon;